import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { IconTik } from './icons';
import { ColorKey } from './theme';

export const ToggleButton = ({ handleCheck, defaultChecked, ...rest }) => {
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setToggle(defaultChecked);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultChecked]);

  const handleChange = (e) => {
    e.stopPropagation();
    if (handleCheck) handleCheck();
    setToggle(!toggle);
  };

  return (
    <ToggleButtonWrapper {...rest} id={toggle ? 'active' : ''} onClick={(e) => handleChange(e)}>
      <input type="hidden" value={String(toggle)} defaultChecked={defaultChecked} />
      <div>
        {toggle && <IconTik />}
      </div>
    </ToggleButtonWrapper>
  );
};

export type ToggleButtonColor =
  'primary'
  | 'warning'
  | 'info'
  | 'success'
  | 'accent'
  | 'background'
  | 'foreground'
  | 'sweet';
export const ToggleButtonColors: Record<ToggleButtonColor, [ColorKey, number]> = {
  primary: ['primary', 900],
  success: ['success', 900],
  info: ['info', 900],
  warning: ['warning', 900],
  background: ['background', 900],
  foreground: ['foreground', 100],
  accent: ['accent', 900],
  sweet: ['sweet', 900],
};
export type ToggleButtonProps = {
  height?: string
  width?: string
  color?: ToggleButtonColor
  justify?: string
  align?: string
}
export const ToggleButtonWrapper = styled.div<ToggleButtonProps>(({
  theme,
  height = '16px',
  width = '36px',
  color = 'primary',
  justify = 'start',
  align = 'center',
}) => {
  const [colorKey, intensity] = ToggleButtonColors[color];
  const size = String(Number(height.split('px')[0]) + 2) + 'px';
  return ({
    backgroundColor: theme.palette.foreground[500][0],
    height,
    width,
    display: 'flex',
    justifyContent: justify,
    alignItems: align,
    borderRadius: '20px',
    position: 'relative',
    cursor: 'pointer',
    '& div': {
      transition: 'all 1s linear',
      position: 'absolute',
      top: '-1px',
      left: 0,
      height: size,
      width: size,
      backgroundColor: theme.palette.foreground[900][0],
      borderRadius: '100%',
      boxShadow: '1px 0 5px #444',
    },
    '&#active': {
      backgroundColor: theme.palette[colorKey][intensity][0],
      '& div': {
        transition: 'all 1s linear',
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& svg rect': {
          fill: theme.palette[colorKey][intensity][0],
        },
      },
    },
  });
});
